import React, {useEffect, useState, useContext} from 'react';
import {
Button,
TextField,
Typography,
CssBaseline,
Container,
} from "@material-ui/core";
import { Paper } from '@material-ui/core';
import { Grid } from '@material-ui/core';
//import Box from '@material-ui/core/Box';
import { makeStyles } from "@material-ui/core/styles";
import WidgetContext from "../../context/widget/widgetContext";
import {
    MdAcUnit,
    MdAddAlarm,
    MdLocationCity,
    MdHome,
    MdBrightness6,
    MdSignalWifi3Bar,
    MdCloud,
    MdRecordVoiceOver,
    MdHeadset,
    MdPets,
    MdPriorityHigh,
    MdWhatshot
} from "react-icons/md";


const useStyles = makeStyles((theme) => ({            
    paper: {
        paddingTop:"30px",
        paddingBottom:"30px",
        borderRadius:"12px",
        width: "200px",
        minHeight:"150px", 
        textAlign: "center",
        "&:hover": {
        backgroundColor: theme.palette.success.light,
        color: theme.palette.background.paper,
        cursor: "pointer",
        },
        //color: theme.palette.text.secondary,
    },
    tittle:{
        marginTop:"0px",
        marginBottom: "10px",
        minWidth: "200px",
        minHeight:"20px", 
        fontWeight: 200
    },
    step: {
        zIndex: 999,
        position: "absolute",
        width: "10%",
        display: "flex",
        flexDirection: "row",
        padding: "0px 1em 0px 0px",
        marginLeft:"80%",
        fontSize: "30px",
    },
    margin: {
        color: "#96FCB3",
        zIndex: 999,
        margin: theme.spacing(1),
        position: "sticky",
        bottom: theme.spacing(1),
        left: "100%",
    },
}));

export default function NuevoWidget ({handlerSelection}){
    const classes = useStyles();
    const widgetContext = useContext(WidgetContext);
    const {
        mensaje,
        agregarWidget,
        errorWidget,
        clearErrorWidget,
        clearOkWidget,
        actualizarWidget,
        obtenerWidgets,
    } = widgetContext;
    const [state, setState]=useState({titulo:""})
    // Cuando el usuario guardar o actualizar el titulo del widget
    const onSubmit = async (e) => {
        e.preventDefault();
        // Validar que no haya campos vacios
        if (state.titulo.trim() === "") {
        errorWidget("Todos los campos son obligatorios", "error");
        return;
        }
        // Pasarlo al action
        /* if (idWidget === "") {
        await agregarWidget(widget).then(value=> obtenerWidgets(cliente));
        } else {
        await actualizarWidget(widget).then(value=> obtenerWidgets(cliente));
        } */
    };
    const onChange = (e) => {
        setState({
            ...state,
            [e.target.name]: e.target.value,
        });
    };

    return (
        <div style={{width:"100%"}}>
            <div className={classes.form} noValidate onSubmit={onSubmit}>
                    {/*< Typography component="h1" variant="h5" style={{marginBottom:"3px"}}> Titulo del Widget </Typography>
                        <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="titulo"
                        name="titulo"
                        value={state.titulo}
                        onChange={onChange}
                        /> */}
                <Grid container spacing={2} direction="row"  justify="center" alignItems="center" style={{ width:"99%", marginLeft:"10px", marginTop:"10px"}}>
                    <Grid item>
                        <Paper className={classes.paper} onClick={() => {handlerSelection('frio')}}>
                            <Typography component="h1" variant="h5">
                                Frio
                            </Typography>
                            <MdAcUnit style={{ fontSize:"100px", color: "#666666"}}/>                        
                        </Paper>
                    </Grid>
                    <Grid item>
                        <Paper className={classes.paper} onClick={() => {handlerSelection('alarma')}}>
                            <Typography component="h1" variant="h5">
                                Alarma
                            </Typography>
                            <MdAddAlarm style={{ fontSize:"100px", color: "#666666"}} />
                        </Paper>
                    </Grid>
                    <Grid item>
                        <Paper className={classes.paper} onClick={() => {handlerSelection('departamento')}}>
                            <Typography component="h1" variant="h5">
                                Departamento
                            </Typography>
                            <MdLocationCity style={{ fontSize:"100px", color: "#666666"}} />
                        </Paper>
                    </Grid>
                    <Grid item>
                        <Paper className={classes.paper} onClick={() => {handlerSelection('casa')}}>
                            <Typography component="h1" variant="h5">
                                Casa
                            </Typography>
                            <MdHome style={{ fontSize:"100px", color: "#666666"}} />
                        </Paper>
                    </Grid>
                    <Grid item>
                        <Paper className={classes.paper} onClick={() => {handlerSelection('luz')}}>
                            <Typography component="h1" variant="h5">
                                Luz
                            </Typography>
                            <MdBrightness6 style={{ fontSize:"100px", color: "#666666"}} />
                        </Paper>
                    </Grid>
                    <Grid item>
                        <Paper className={classes.paper} onClick={() => {handlerSelection('conexion')}}>
                            <Typography component="h1" variant="h5">
                                Conexión 
                            </Typography>
                            <MdSignalWifi3Bar style={{ fontSize:"100px", color: "#666666"}}/>
                        </Paper>
                    </Grid>
                    <Grid item>
                        <Paper className={classes.paper} onClick={() => {handlerSelection('clima')}}>
                            <Typography component="h1" variant="h5">
                                Clima
                            </Typography>
                            <MdCloud style={{ fontSize:"100px", color: "#666666"}} fill="none" />
                        </Paper>
                    </Grid>
                    <Grid item>
                        <Paper className={classes.paper} onClick={() => {handlerSelection('flora')}}>
                            <Typography component="h1" variant="h5">
                                Flora
                            </Typography>
                            <MdRecordVoiceOver style={{ fontSize:"100px", color: "#666666"}}/>
                        </Paper>
                    </Grid>
                    <Grid item >
                        <Paper className={classes.paper} onClick={() => {handlerSelection('sonido')}}>
                            <Typography component="h1" variant="h5">
                                Sonido
                            </Typography>
                            <MdHeadset style={{ fontSize:"100px", color: "#666666"  }} />
                        </Paper>
                    </Grid> 
                    <Grid item >
                        <Paper className={classes.paper} onClick={() => {handlerSelection('mascota')}}>
                            <Typography component="h1" variant="h5">
                                Mascota
                            </Typography>
                            <MdPets style={{ fontSize:"100px", color: "#666666"  }} />
                        </Paper>
                    </Grid> 
                    <Grid item >
                        <Paper className={classes.paper} onClick={() => {handlerSelection('importante')}}>
                            <Typography component="h1" variant="h5">
                                Importante
                            </Typography>
                            <MdPriorityHigh style={{ fontSize:"100px", color: "#666666"  }} />
                        </Paper>
                    </Grid> 
                    <Grid item >
                        <Paper className={classes.paper} onClick={() => {handlerSelection('calor')}}>
                            <Typography component="h1" variant="h5">
                                Calor
                            </Typography>
                            <MdWhatshot style={{ fontSize:"100px", color: "#666666"  }} />
                        </Paper>
                    </Grid> 
                    </Grid>
            <Grid container direction="row" justify="flex-end" alignItems="center">
        </Grid>
        </div>    
        </div>
    )

}